import { useCallback, useMemo, useState } from "react";

import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import Joi from "joi-browser";

import { Button } from "V2.0/common/button";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";

export default AssistantCoachPrompt;

const schema = {
  coachPrompt: Joi.string().max(30000).required().label("Coach Prompt"),
};

const template = [
  {
    name: "coachPrompt",
    type: "textArea",
    style: { fontSize: "14px" },
  },
];

function AssistantCoachPrompt(props) {
  const { assistantCoach, onUpdateAssistant, isUnlocked } = props;

  const [inputField] = useState({
    coachPrompt: assistantCoach?.coachPrompt ?? "",
  });
  const [notifyChange, setNotifyChange] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const { data, setData, error, handleChange } = useForm(
    inputField,
    schema,
    () => setNotifyChange(true),
  );

  const onSavePrompt = useCallback(async (data) => {
    const payload = data;
    const lifecycleCbs = {
      init() {
        setLoading(true);
        message.loading("Updating Prompt");
      },
      success() {
        setLoading(false);
        message.destroy();
        message.success("Prompt Updated");
      },
      error(e) {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to update prompt");
      },
    };

    onUpdateAssistant(payload, lifecycleCbs);
  }, []);

  const onRevertPrompt = useCallback((prompt) => {
    setData(prompt);
    setNotifyChange(false);
    message.success("Changes Reverted");
  }, []);

  const updatedTemplate = useMemo(() => {
    return template.map((field) => {
      return {
        ...field,
        disabled: !isUnlocked,
      };
    });
  }, [isUnlocked]);

  const disableSavePrompt = !notifyChange || Object.keys(error).length > 0;

  return (
    <div className="flex flex-col w-full h-full gap-y-4 p-4">
      <div className="h-full flex-1 w-full">
        <Form
          data={data}
          handleChange={handleChange}
          error={error}
          template={updatedTemplate}
        />
      </div>
      {isUnlocked && (
        <div className="flex shrink-0 gap-x-2">
          <Button
            loading={loading}
            disabled={disableSavePrompt}
            onClick={() => onSavePrompt(data)}
          >
            Save Prompt
          </Button>
          <Button
            onClick={() => onRevertPrompt(assistantCoach?.coachPrompt ?? "")}
            outline
          >
            Revert
          </Button>
        </div>
      )}
    </div>
  );
}
